<template>
  <div v-if="0 < index" class="transaction-separator">
    <svg xmlns="http://www.w3.org/2000/svg" width="202" height="2" viewBox="0 0 202 2" fill="none">
      <path d="M1 1H201" stroke="#275CF1" stroke-opacity="0.04" stroke-linecap="round"/>
    </svg>
  </div>
  <TransactionModal :transaction="transaction" :id="transaction.date + '-' + index" />
  <div
    class="transaction-line"
    :target-modal="'transaction-modal-' + transaction.date + '-' + index"
    :class="{
      'transaction-line-failed': transaction.state.isFailed,
      'transaction-line-pending': 'pending' === transaction.state.state,
      'transaction-line-credit': ('completed' === transaction.state.state || 'completed_refund' === transaction.state.state || 'completed_funding' === transaction.state.state) && 'credit' === transaction.side
    }"
    :onClick="showModal"
  >
    <div class="transaction-part-1">
      <div v-if="transaction.merchant.name.length < 20 " class="transaction-merchant">
        {{ transaction.merchant.name }}
      </div>
      <div  v-else class="transaction-merchant tooltip">
        {{ transaction.merchant.name.substr(0, 18) }}...
        <span class="tooltiptext">{{ transaction.merchant.name }}</span>
      </div>

      <div class="transaction-time">
        <div class="transaction-time-icon">
          <img src="@/assets/img/ico/time.svg" />
        </div>
        <div class="transaction-time-text">
          {{ transaction.time }}
        </div>
      </div>
    </div>
    <div class="transaction-part-2">
      <div v-if="transaction.state.isFailed" class="transaction-error">
        <div class="transaction-error-icon">
          <img src="@/assets/img/ico/cross_red.svg" />
        </div>
        <div class="transaction-error-text">
          <span class="display-mobile">{{ $t("transaction.transactionRefused") }}</span>
          <span class="display-web">{{ $t("transaction.transactionRefused") }} : {{ $t("transaction.errorMessage." + transaction.state.state) }}</span>
        </div>
      </div>
    </div>
    <div class="transaction-part-3">
      <div class="transaction-amount">
        <div v-if="'pending' === transaction.state.state" class="transaction-amount-icon-pending">
          <img src="@/assets/img/ico/hourglass.svg" />
        </div>
        <div>
          <span v-if="0 < transaction.amount">+</span>{{ (transaction.amount/100).toLocaleString('fr-FR', { minimumFractionDigits: 2 }) }}€
        </div>
      </div>

      <div v-if="'completed_credit_funding' !== transaction.type && transaction.campaign.name.length < 20" class="transaction-campaign">
        {{ transaction.campaign.name }}
      </div>
      <div v-if="'completed_credit_funding' !== transaction.type && transaction.campaign.name.length >= 20" class="transaction-campaign tooltip">
        {{ transaction.campaign.name.substr(0, 18) }}...
        <span class="tooltiptext">{{ transaction.campaign.name }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import TransactionModal from "@/components/Transaction/TransactionModal.vue";

  const props = defineProps({
    'index': {
      type: Number
    },
    'display': {
      type: String
    },
    'transaction': {
      type: Object,
      default: () => ({
        merchant: null,
        campaign: null,
        socialEvent: null,
        date: null,
        time: null,
        timestamp: null,
        amount: null,
        side: null,
        expired: null,
        state: null,
        type: null
      })
    }
  })

  const showModal = (e) => {
    let width = window.innerWidth;

    if (width > 630) {
      return;
    }

    let modals = document.getElementsByClassName('transaction-modal');

    for (let i = 0; i < modals.length; i++) {
      modals[i].style.display = "none";
    }

    document.getElementById(e.target.closest('.transaction-line').getAttribute('target-modal')).style.display = "block";
    document.body.style.overflowY = 'hidden';
  }
</script>

<style scoped lang="scss">
  .transaction-separator {
    width: 100%;
    stroke-width: 1px;
    stroke: var(--ce-color-blue-ce-marque-blanche-50, rgba(39, 92, 241, 0.04));
    display: flex;
    justify-content: center;
  }

  .transaction-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    background: #FFF;
    padding: 5px;

    /*Mobile screen*/
    @media only screen and (max-width: 630px) {
      cursor: pointer;
    }

    .transaction-part-1 {
      text-align: left;
      width: 178px;

      @media only screen and (max-width: 761px) {
        width: 100px;
        overflow-x : hidden;
      }

      .transaction-merchant {
        font-size: 14px;
        font-weight: 700;
      }

      .transaction-time {
        display: flex;
        align-items: center;
        gap: 4px;

        .transaction-time-icon {
          width: 12px;
          height: 12px;
          aspect-ratio: 1/1;
        }

        .transaction-time-text {
          color: var(--text-theme_light-low_em, #8D8A95);
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
        }
      }
    }

    .transaction-part-2 {
      flex-grow: 1;

      @media only screen and (min-width: 800px) {
        padding-left: 40px;
      }

      @media only screen and (min-width: 900px) {
        padding-left: 50px;
      }

      .transaction-error {
        display: flex;
        align-items: center;
        gap: 4px;

        @media only screen and (max-width: 630px) {
          justify-content: center;
        }

        .transaction-error-icon {
          width: 16px;
          height: 16px;
        }

        .transaction-error-text {
          span {
            text-align: left;
          }
        }
      }
    }

    .transaction-part-3 {
      .transaction-amount {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 4px;
        width: 110px;

        text-align: right;
        font-size: 14px;
        font-weight: 700;
        line-height: 24px;

        .transaction-amount-icon-pending {
          width: 16px;
          height: 16px;
        }
      }

      .transaction-campaign {
        text-align: right;
        font-size: 10px;
        font-weight: 400;
      }
    }
  }

  .transaction-line-credit {
    color: var(--CE-Brand-Primaire-500, #275CF1);
  }

  .transaction-line-pending {
    color: var(--ce-color-dark-blue-ce-marque-blanche-500, #0B1C48);
    opacity: 0.5;
  }

  .transaction-line-failed {
      color: var(--CE-Brand-Danger-Danger-light, #F03D3D);
  }

  /*Web screen*/
  @media only screen and (min-width: 630px) {
    .display-web {
      display: block;
    }

    .display-mobile {
      display: none;
    }
  }

  /*Mobile screen*/
  @media only screen and (max-width: 630px) {
    .display-web {
      display: none;
    }

    .display-mobile {
      display: block;
    }
  }
</style>
